import PropTypes from 'prop-types';
import styled from 'styled-components';

import { mediaMax } from '@styles/sizes';

export const Background = styled.div`
  background: ${props => props.bg};
  padding: 32px 0;
  margin-bottom: 160px;
  ${mediaMax.container`
    margin-bottom: 40px;
  `}
`;

Background.propTypes = {
  bg: PropTypes.string.isRequired,
}